<trp-community-widget>
  <trp-community-widget-header
    [title]="widgetDefinition.title | translate"
    [icon]="widgetDefinition.icon"
    [infoText]="(widgetDefinition.infoText ?? '') | translate: { contactHref: contactHref ?? 'mailto:solutionshub@recyclingpartnership.org' }"
  ></trp-community-widget-header>
  <trp-community-widget-content>
    <div class="widget-content">
      <ng-container
        *ngIf="widgetDefinition.ifInfoAvailable(sectionCommunityInfo); else na"
      >
        <ng-container
          *ngIf="
            widgetDefinition?.availableValueFormat === 'html';
            else regularFormat
          "
        >
          <div
            [innerHTML]="
              widgetDefinition.availableResolver(sectionCommunityInfo)
            "
          ></div>
          <div
            *ngIf="
              !!widgetDefinition.measurementYear &&
              widgetDefinition.measurementYear(sectionCommunityInfo)
            "
            class="reported-year"
          >
            {{ widgetDefinition.measurementYear(sectionCommunityInfo) }}
          </div>
        </ng-container>
        <ng-template #regularFormat>
          {{ widgetDefinition.availableResolver(sectionCommunityInfo) }}
        </ng-template>
      </ng-container>
      <ng-template #na>
        <span [innerHTML]="getUnavailableMessage()"></span>
      </ng-template>
    </div>
  </trp-community-widget-content>
</trp-community-widget>
